<template>
    <div>
        <Kefu />
    </div>
</template>

<script>
import Kefu from "./kefuView.vue";
export default {
    components: {
        Kefu,
    },
    data() {
        return{
            
        }
    },
    created(){
        
    }
};
</script>
